import Page from './page.connect'

export default Page



// WEBPACK FOOTER //
// ./src/components/common/page/index.js